/**
 * 正式服/rc服自动识别跳转的相关逻辑
 *
 * 基本实现原理：
 * - 后台条件：正式服/rc服的登录token是通用的，需要在用户登录后，把登录相关的信息共享给另一个服务器即可
 * - 技术基础：通过共同顶级域名`leyopharm.com`来共享sessionStorage
 * - 最终目的：将当前登录用户的`sop_test_admin_COMMON__SESSION__KEY__`所有信息设置到目标域名
 */

import { BOOLEAN } from '@/utils/constants'

/** 部署服务器 */
export enum BUILD_ENVS {
  /** 本地开发 */
  DEV = 'development',
  /** 测试服 */
  TEST = 'staging',
  /** 灰度测试服/rc服 */
  RC = 'canary',
  /** 正式服 */
  PRO = 'production'
}
/** 当前服务器 */
const CUR_BUILD_ENV = import.meta.env.VITE_BUILD_ENV

/** 正式服域名 */
const HOST_FORMAL = import.meta.env.VITE_HOST_FORMAL
/** rc服域名 */
const HOST_RC = import.meta.env.VITE_HOST_RC

/**
 * 对当前用户进行正式服/rc服的分发
 * @param beLoginRc
 */
export function dispatchServer(beLoginRc: BOOLEAN) {
  let from = ''
  let to = ''
  if (beLoginRc === BOOLEAN.YES && CUR_BUILD_ENV === BUILD_ENVS.PRO) {
    // 用户分发至rc服，获取rc服跳转地址
    from = HOST_FORMAL
    to = HOST_RC
  } else if (beLoginRc === BOOLEAN.NO && CUR_BUILD_ENV === BUILD_ENVS.RC) {
    // 用户分发至正式服，获取正式服跳转地址
    from = HOST_RC
    to = HOST_FORMAL
  }
  if (from && to) {
    const url = location.href.replace(from, to)
    return () => {
      window.location.href = url
    }
  }
}
